import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuard } from '@api/user/Guard';

const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () => import('./features')
      .then(m => m.FeaturesModule),
    canActivate: [ AuthGuard],
  },
  {
    path: '',
    loadChildren: () => import('./login')
      .then(m => m.LoginModule),
  },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
